// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__5C_mg","savePackageButton":"ClientWallet_savePackageButton__UsNev"};